import React, {PureComponent} from "react";
import "../resources/css/progression.css";
import {ProgressionLevelEntity} from "../data/entities/ProgressionLevelEntity";
import ProgressionLevelItem from "./ProgressionLevelItem";
import {FormattedMessage} from "react-intl";
import {ScaleLoader} from "react-spinners";
import {Row} from "reactstrap";
import {UserProgressionInfoEntity} from "../data/entities/UserProgressionInfoEntity";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {OverflowChangedArgs} from "overlayscrollbars";
import ErrorMessage from "./ErrorMessage";

const plusProgramLogo = require("../resources/img/plus-program-logo.png");

interface Props {
    progressionLevels: ProgressionLevelEntity[];
    isLoadingProgressionLevels: boolean;
    hasError: boolean;
    refreshProgressionData: () => void;
    userProgressionInfo: UserProgressionInfoEntity;
}

export default class ProgressionLevels extends PureComponent<Props> {
    render(): JSX.Element {
        return (
            <div className="uplayBenefits" id="nav-anchor-benefits">
                <div className="headerSection">
                    <img src={plusProgramLogo} alt="" />
                    <FormattedMessage id="progression.benefits.description" tagName="h3" />
                </div>
                <div className="contents">
                    {
                        this.props.hasError &&
                        <div className="text-center block pt-5">
                            <ErrorMessage
                                message={<FormattedMessage id="message.error"/>}
                                onRefresh={this.props.refreshProgressionData}
                            />
                        </div>
                    }
                    {
                        !this.props.isLoadingProgressionLevels && !this.props.hasError &&
                        <OverlayScrollbarsComponent
                            options={{
                                scrollbars: {
                                    snapHandle: true,
                                        clickScrolling: true
                                },
                                callbacks: {
                                    onOverflowChanged: this.handleOverflowChanged
                                }
                            }}
                        >
                            <Row className="progression-levels-list">
                                {
                                    this.props.progressionLevels.map((progressionLevel, index) => {
                                        if (progressionLevel.image) {
                                            return (
                                                <ProgressionLevelItem
                                                    key={index}
                                                    progressionLevel={progressionLevel}
                                                    userProgressionInfo={this.props.userProgressionInfo}
                                                />
                                            );
                                        }

                                        return null;
                                    })
                                }
                            </Row>
                        </OverlayScrollbarsComponent>
                    }
                    {
                        this.props.isLoadingProgressionLevels &&
                            <div className="item-loader">
                                <ScaleLoader color={'#fff'}/>
                            </div>
                    }
                </div>
            </div>
        );
    }

    handleOverflowChanged(this: OverlayScrollbars, args?: OverflowChangedArgs) {
        if (args && args.x && args.clipped) {

            const scrollToActive = (): boolean => {
                const activeLevel = document.getElementById("active-progression-level");
                if (activeLevel) {
                    this.scroll(activeLevel);
                    return true;
                }
                return false;
            };

            (async () => {
                if (!scrollToActive()) {
                    let interval = setInterval(() => {
                        if (scrollToActive()) {
                            clearInterval(interval);
                        }
                    }, 50);
                }
            })();
        }
    };
}